'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Customer API
 */
var Customer = function (_CoveAPI) {
  (0, _inherits3.default)(Customer, _CoveAPI);

  /**
   * Creates a new Customer API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Customer(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Customer);
    return (0, _possibleConstructorReturn3.default)(this, (Customer.__proto__ || (0, _getPrototypeOf2.default)(Customer)).call(this, host, 'customer/v1', environment, auth));
  }

  (0, _createClass3.default)(Customer, [{
    key: 'countPolicies',
    value: function countPolicies(customerId, type) {
      var includeFutureDated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var params = {
        customer_id: customerId,
        type: type
      };
      if (includeFutureDated) {
        params.include_future_dated = 'yes';
      }
      return this.apiClient.fetch('GET', 'count-policies', params).then(function (data) {
        return data.count;
      });
    }

    /**
     * Retrieves the customer
     * @param {string} customer_id
     */

  }, {
    key: 'retrieve',
    value: function retrieve(customer_id) {
      return this.apiClient.fetch('GET', 'retrieve', { customer_id: customer_id }).then(function (data) {
        return data.customer;
      });
    }

    /**
     * Creates a new customer
     * @param {*} customer
     */

  }, {
    key: 'create',
    value: function create(customer) {
      return this.apiClient.fetch('POST', 'create', null, { customer: customer }).then(function (data) {
        return data.customer;
      });
    }

    /**
     * Updates the customer
     * @param {*} customer
     */

  }, {
    key: 'update',
    value: function update(customer, preview, payment) {
      return this.apiClient.fetch('POST', 'update', { preview: preview ? 'true' : 'false' }, { customer: customer, payment: payment }).then(function (data) {
        return data.customer;
      });
    }

    /**
     * Updates the customer
     * @param {*} customer
     */

  }, {
    key: 'updateReferee',
    value: function updateReferee(customer) {
      return this.apiClient.fetch('POST', 'update-referee', null, { customer: customer }).then(function (data) {
        return data.customer;
      });
    }

    /**
     * Retrieve by a particular id type
     * @param {string} id_type
     * @param {string} id_value
     */

  }, {
    key: 'retrieveBy',
    value: function retrieveBy(id_type, id_value) {
      var params = {};
      params[id_type] = id_value;

      return this.apiClient.fetch('GET', 'retrieve', params).then(function (data) {
        return data.customer;
      });
    }

    /**
     * Query a customer by referral code
     * @param {string} referral_code
     */

  }, {
    key: 'queryByReferral',
    value: function queryByReferral(referral_code) {
      return this.apiClient.fetch('GET', 'retrieve', { referral_code: referral_code }).then(function (data) {
        return data.customer;
      });
    }

    /**
     * Delete a customer with the given facebook_id
     * @param {string} facebook_id
     */

  }, {
    key: 'delete',
    value: function _delete(facebook_id) {
      return this.apiClient.fetch('POST', 'delete', null, {
        customer: {
          facebook_id: facebook_id
        }
      });
    }

    /**
     * Get all drivers for a customer with the given customer_id
     * @param {string} customer_id
     */

  }, {
    key: 'getDrivers',
    value: function getDrivers(customer_id) {
      return this.apiClient.fetch('GET', 'get-drivers', { customer_id: customer_id }).then(function (data) {
        return data.drivers;
      });
    }

    /**
     * Get referral summary for a customer with the given customer_id
     * @param {string} customer_id
     */

  }, {
    key: 'getReferralSummary',
    value: function getReferralSummary(customer_id) {
      return this.apiClient.fetch('GET', 'referral-summary', { customer_id: customer_id }).then(function (data) {
        return data.referral_summary;
      });
    }
  }]);
  return Customer;
}(_CoveApi2.default);

exports.default = Customer;